module.exports = __webpack_public_path__ + "img/down-arrow.e8704169.svg";